<button
  [attr.aria-label]="showButton ? null : ('areaOfUse.addProductToAreaOfUse_action' | cxTranslate)"
  [ngbTooltip]="'areaOfUse.addProductToAreaOfUse_tooltip' | cxTranslate"
  [disableTooltip]="disableTooltip"
  #popOver="ngbPopover"
  class="btn btn-ternary btn-icon"
  [class.open]="popOver.isOpen()"
  [ngbPopover]="popoverTemplate"
  [popoverClass]="'add-to-area-of-use-popover'"
  [autoClose]="'outside'"
  [placement]="'auto'"
>
  <i nz-icon nzType="read"></i>
  <span class="pl-2" *ngIf="showButton">{{ 'areaOfUse.addProductToAreaOfUse_action' | cxTranslate }}</span>
</button>

<ng-template #popoverTemplate>
  <div class="area-of-use" *ngIf="{ categories: categories$ | async, loading: loading$ | async } as data">
    <div class="d-flex justify-content-between align-items-center px-3 pt-4 pb-3 w-100">
      <h6>
        {{ 'areaOfUse.addProductToAreaOfUse_title' | cxTranslate }}
      </h6>
      <button type="button" class="ml-4 close" [attr.aria-label]="'common.cancel_action' | cxTranslate" (click)="popOver.close()">
        <i nz-icon pyIconThemeReverse nzType="close-circle" nzTheme="outline"></i>
      </button>
    </div>
    <ng-container *ngIf="data.categories && !data.loading; else loadingTemplate">
      <py-search-field
        [group]="formGroup"
        [fieldName]="'search'"
        [placeholder]="'areaOfUse.searchForSection_placeholder' | cxTranslate"
        (handleReset)="onResetSearchForm()"
      ></py-search-field>
      <ul class="category" *ngFor="let category of data.categories">
        <span class="category-title py-2 px-4"> {{ category.name }}</span>

        <li
          *ngFor="let subCategory of category.subCategories | filter: filterBy : 'name'"
          class="subcategory d-flex justify-content-between align-items-center"
          (click)="onSubcategoryClick(subCategory?.productCodes?.includes(productCode), subCategory.code)"
        >
          <span class="subcategory-title py-3 px-4">{{ subCategory?.name }}</span>
          <i
            *ngIf="subCategory?.productCodes?.includes(productCode)"
            nz-icon
            nzType="check-circle"
            nzTheme="fill"
            class="subcategory-checkmark mr-2 text-primary"
          ></i>
        </li>
      </ul>
    </ng-container>
  </div>
</ng-template>

<ng-template #loadingTemplate>
  <div class="m-3">
    <div class="skeleton py-2 my-1 w-100"></div>
    <div class="skeleton py-2 my-1 w-100"></div>
    <div class="skeleton py-2 my-1 w-100"></div>
  </div>
</ng-template>
